import React from 'react';

function SocialsIcon(props: JSX.IntrinsicElements['svg']) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="65"
      height="65"
      viewBox="0 0 65 65">
      <defs>
        <circle id="s9ia3ehxkb" cx="22.5" cy="22.5" r="22.5" />
        <circle id="u6fx9gvl0c" cx="13.5" cy="2.7" r="2.7" />
        <circle id="txjo8lc1rd" cx="2.7" cy="9" r="2.7" />
        <circle id="i9jq24sawe" cx="13.5" cy="15.3" r="2.7" />
        <filter
          id="zei2xhp26a"
          width="171.1%"
          height="171.1%"
          x="-35.6%"
          y="-31.1%"
          filterUnits="objectBoundingBox">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius=".5"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dy="2"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="4.5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0.587254514 0 0 0 0 0.733802722 0 0 0 0 0.837975543 0 0 0 0.526480721 0"
          />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g transform="translate(-1448 -767) translate(1458 775)">
              <use
                fill="#000"
                filter="url(#zei2xhp26a)"
                xlinkHref="#s9ia3ehxkb"
              />
              <use fill="#3DB2FF" xlinkHref="#s9ia3ehxkb" />
            </g>
            <g stroke="#FFF" strokeLinecap="round" strokeLinejoin="round">
              <g transform="translate(-1448 -767) translate(1458 775) translate(13.5 13.5)">
                <use fill="#FFF" strokeWidth="2" xlinkHref="#u6fx9gvl0c" />
                <use xlinkHref="#u6fx9gvl0c" />
              </g>
              <g transform="translate(-1448 -767) translate(1458 775) translate(13.5 13.5)">
                <use fill="#FFF" strokeWidth="2" xlinkHref="#txjo8lc1rd" />
                <use xlinkHref="#txjo8lc1rd" />
              </g>
              <g transform="translate(-1448 -767) translate(1458 775) translate(13.5 13.5)">
                <use fill="#FFF" strokeWidth="2" xlinkHref="#i9jq24sawe" />
                <use xlinkHref="#i9jq24sawe" />
              </g>
              <path
                strokeWidth="2"
                d="M5.031 10.359L11.178 13.941M11.169 4.059L5.031 7.641"
                transform="translate(-1448 -767) translate(1458 775) translate(13.5 13.5)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SocialsIcon;
